import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HelpService } from '/app/services/help/help.service';

@Component({
  selector: 'app-alert',
  standalone: true, // 👈 asegúrate de declararlo como standalone
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,   // 👈 Necesario para *ngIf y [ngClass]
    MatIconModule,
    MatButtonModule,
    MatTooltipModule
  ]
})
export class AlertComponent implements OnInit {
  @Input() type: 'success' | 'error' | 'warning' | 'info' = 'info';
  @Input() message: string = '';
  @Input() autoClose: boolean = true;
  @Input() duration: number = 4000; // milisegundos

  visible = true;

  constructor(private helpService: HelpService) {}

  showHelp(): void {
    this.helpService.startTour(this.helpService.getAlertHelpSteps());
  }

  ngOnInit(): void {
    if (this.autoClose) {
      setTimeout(() => {
        this.visible = false;
      }, this.duration);
    }
  }

  closeAlert(): void {
    this.visible = false;
  }
}
